import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import _ from "lodash";

import Alert from "components/shared/common/alert";
import { onLogOut } from "components/shared/utils/onLogOut";
import { setIsLoading } from "redux/loader/action";
import { set_password_reset_details } from "redux/signin/action";
import InputContainer from "./components/InputContainer";

const PasswordReset = ({ history }) => {
  const dispatch = useDispatch();
  const {
    signinReducer: { password_reset_details }
  } = useSelector((state) => state);

  const { email, code_success } = password_reset_details;
  const [resetPasswordDetails, setResetPasswordDetails] = useState({
    code: "",
    password: "",
    confirm_password: ""
  });

  const [resetPasswordErrors, setResetPasswordErrors] = useState({
    code: "",
    password: "",
    confirm_password: ""
  });

  const handleIsLoading = (value) => dispatch(setIsLoading(value));

  const passwordMismatches = (value = resetPasswordDetails.confirm_password) =>
    resetPasswordDetails.confirm_password === "" ||
    resetPasswordDetails.password !== value;

  const handleInputChange = (value, name) => {
    if (
      (name === "code" && value.length === 6) ||
      (name === "password" && value.length > 7) ||
      (name === "confirm_password" && !passwordMismatches(value))
    ) {
      setResetPasswordErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setResetPasswordDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendEmailCode = () => {
    const email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!email_regex.test(email)) {
      Alert(400, "Please enter a valid email address.");
    } else {
      handleIsLoading(true);
      Auth.forgotPassword(email)
        .then(() => {
          handleIsLoading(false);
          dispatch(
            set_password_reset_details({
              ...password_reset_details,
              code_success: true
            })
          );
        })
        .catch((err) => {
          handleIsLoading(false);
          if (err.code === "UserNotFoundException") {
            Alert(400, "User not found");
          } else {
            Alert(400, err.message);
          }
        });
    }
  };

  const handleResetPassword = () => {
    let errorObj = { ...resetPasswordErrors };
    const { code, password } = resetPasswordDetails;
    if (code === "" || code.length !== 6)
      errorObj.code = "Code could not be verified. Try again.";
    if (password === "" || password.length < 8)
      errorObj.password = "Passwords must be 8 characters.";
    if (passwordMismatches())
      errorObj.confirm_password = "Passwords must be same.";
    if (
      errorObj.code === "" &&
      errorObj.password === "" &&
      errorObj.confirm_password === ""
    ) {
      handleIsLoading(true);
      Auth.forgotPasswordSubmit(email, code, password)
        .then(async (data) => {
          if (data === "SUCCESS") {
            Alert(200, "Password changed successfully.");
            await onLogOut(true);
            handleIsLoading(false);
            history.push("/signup");
          }
        })
        .catch((err) => {
          if (err.code.includes("Code")) {
            setResetPasswordErrors((prev) => ({
              ...prev,
              code: "Code could not be verified. Try again."
            }));
          }
          handleIsLoading(false);
        });
    } else {
      setResetPasswordErrors(errorObj);
    }
  };

  return (
    <div className="password-reset-main">
      {!code_success ? (
        <h2 className="title">
          Forgot
          <br />
          Password?
        </h2>
      ) : (
        <h2 className="title">Reset Password</h2>
      )}
      <p className="desc password-reset">
        {!code_success
          ? `Enter your email address and we will send you instructions to reset your
        password.`
          : `Enter the code sent to your account’s email. The create your new password`}
      </p>

      {!code_success ? (
        <input
          name="name"
          type="text"
          value={email}
          className="input-div password-reset"
          placeholder="Email Address"
          onChange={(e) =>
            dispatch(
              set_password_reset_details({
                ...password_reset_details,
                email: e.target.value
              })
            )
          }
        />
      ) : (
        <InputContainer
          errors={resetPasswordErrors}
          details={resetPasswordDetails}
          onInputChange={handleInputChange}
        />
      )}

      <button
        className="onboarding-button"
        onClick={!code_success ? handleSendEmailCode : handleResetPassword}
      >
        {!code_success ? "Continue" : "Reset Password"}
      </button>

      <p className="password-reset-bottom-text">
        Remembered your password?{" "}
        <span onClick={() => history.push("/signup")}>Back to Log In</span>
      </p>
    </div>
  );
};

export default PasswordReset;
